module.exports = __webpack_public_path__ + "img/phhp-cold-water.72c840f0.jpg";